export const COLORS = {
  BG_APP: "#f7f7f7",
  JAFFA: "#F48A2E",
  GOLD_TIPS: "#EBC61A",
  BOULDER: "#7B7B7B",
  CURIOUS_BLUE: "#1A89E9",
  KEY_LIME_PIE: "#BFD62A",
  DOWNY: "#6EC8D0",
  TIDE: "#C2B8B4",
  ORANGE: "#FF8002",
  LIGHT_GRAY: "#848484",
  MIDNIGHT_BLUE: "#002067",
  LIGHT_BLUE: "#0085DF",
  CHAMBRAY: "#314783",
  FUN_GREEN: "#009131",
  CORN: "#E5B900",
  PERSIMMON: "#FF5F57",
  ALTO: "#E0E0E0",
  DOVE_GRAY: "#707070",
  GALLERY: "#EFEFEF",
  JAPANESE_LAUREL: "#00A70D",
  GUARDSMAN_RED: "#C10000",
  SCORPION: "#5F5F5F",
  LA_PALMA: "#15AC20",
  LIMA: "#68C90E",
  BUDDHA_GOLD: "#BAA209",
  TUNDORA: "#474747",
  SCARLETT: "#A2040D",
  AZURE_RADIANCE: "#0075EB",
  WISTERIA: "#9B59B6",
  CASABLANCA: "#F7BB4D",
};
